<template>
  <div>
    <!-- <div class="public-notice">
      <el-carousel
        direction="vertical"
        :autoplay="true"
        indicator-position="none"
      >
        <el-carousel-item v-for="item in noticesList" :key="item.noticeId">
          <div class="medium" @click="jumpNoticeDetail(item)">
            <icon-svg icon-class="notice-public" style="margin: 0 12px;"/>{{ item.noticeTitle }}
          </div>
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="userCenter warp">
      <div class="leftMenu">
        <div class="leftMenuBox">
          <el-menu :default-active="defaultActive" router>
            <div v-for="(group, index) in groupedRouterAll" :key="index">
              <div class="parent-title">
                {{ group.parentMenu }}
              </div>
              <div v-for="(item, itemIndex) in group.items" :key="item.path || itemIndex">
                <el-menu-item class="flex-start" :index="item.name">
                  <span class="title">
                    <!-- <icon-svg style="width: 30px; height:30px;" icon-class="user-order" /> -->
                    {{ item.meta.title }}
                  </span>
                </el-menu-item>
              </div>
            </div>
          </el-menu>
          <!-- <el-menu :default-active="defaultActive" active-text-color="#C5AA7B" router>
            <el-menu-item class="flex-start" index="userInfo">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-info" />
                个人信息
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="message"><el-badge :value="userInfo.notRead" class="item"><span
                  class="title">我的消息</span></el-badge></el-menu-item>
            <el-menu-item class="flex-start" index="message">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-notice" />
                我的消息<span class="tip" v-if="userInfo.notRead">{{ userInfo.notRead }}</span>
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="myOrder">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-order" />
                我的订单
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="qaList">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-wenda" />
                我的问答
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="orderAfterSale">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-shouhou" />
                售后订单
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="myEvaluate">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-pingjia" />
                我的评价
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="signingAddress">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-dingwei" />
                收货地址
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="changePwd"><span class="title">更改密码</span></el-menu-item>
            <el-menu-item class="flex-start" index="favorites">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-favorite" />我的收藏
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="browseRecords">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-foot" />浏览足迹
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="couponPackage">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-coupon" />我的卡券
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="changePhone">
              <span class="title">
                <icon-svg style="width: 30px; height:30px;" icon-class="user-resetphone" />更换手机号
              </span>
            </el-menu-item>
            <el-menu-item class="flex-start" index="unbindPhone"><span class="title">解绑手机</span></el-menu-item>
          </el-menu> -->
        </div>
      </div>
      <div class="userCenterInfo">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import { mapGetters } from 'vuex'
import {
  getGongGaoAll
} from '@/api/user/notice.js'
export default {
  name: 'userCenter',
  data () {
    return {
      noticesList: [],
      swiperOption: {
        autoplay: true, // 可选选项，自动滑动
        loop: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  watch: {
    routerAll: {
      handler (newVal, oldVal) {
        // console.log('routerAll changed:', newVal)
        if (newVal.length === 0) {
          this.$store.commit('SET_HOMEPAGEROUTES')
        }
        // 强制更新视图
        this.$forceUpdate()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    if (!Cookie.get('token')) {
      // this.$message.warning('请先登录')
      this.$store.commit('resetVuex')
      // this.$router.push({path: '/login'})
      this.$store.commit('IS_LOGIN', false)
      this.$store.commit('SHOW_LOGIN')
    }
    // this.getNoticesData()
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'routerAll'
    ]),
    defaultActive: function () {
      return this.$route.path.replace('/', '')
    },
    groupedRouterAll () {
      const visibleRoutes = this.routerAll.filter(item => !item.hidden)
      const map = new Map()
      visibleRoutes.forEach(item => {
        const parentMenu = item.parentMenu
        if (!map.has(parentMenu)) {
          map.set(parentMenu, {
            key: parentMenu,
            parentMenu: parentMenu,
            items: []
          })
        }
        map.get(parentMenu).items.push(item)
      })
      // 转换为数组并排序
      // .sort((a, b) => a.parentMenu.localeCompare(b.parentMenu))
      return Array.from(map.values())
    }
  },
  methods: {
    async getNoticesData () {
      const response = await getGongGaoAll()
      const res = response.data
      this.noticesList = res.data
    },
    jumpNoticeDetail (item) {
      this.$router.push({
        path: '/activity/notificationDetails',
        query: {
          id: item.noticeId
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.public-notice {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #666666;

  .el-carousel {
    max-width: 1250px;
    height: 100%;
    margin: auto;
    color: #FFF;
    cursor: pointer;
  }
}

.userCenter {
  margin-top: 20px;
  display: flex;

  .leftMenu {
    width: 200px;
    min-height: calc(100vh - 140px);
    background-color: #fff;
    margin-right: 20px;

    .leftMenuBox {
      padding: 8px;
      background: #fff;

      .parent-title {
        color: #181818;
        font-weight: bold;
        font-size: 16px;
        height: 48px;
        padding: 16px 16px 8px 16px;
      }

      >>>.el-menu {
        border-right: none;
      }

      >>>.el-menu-item {
        padding: 0 !important;
        display: block;
        height: 36px;
        line-height: 36px;
        .title {
          width: 100%;
          height: 36px;
          line-height: 36px;
          position: relative;
          color: #4B5B76;
          padding: 7px 16px;
          .svg-icon {
            position: absolute;
            top: -6px;
            left: 20px;
          }
        }

        .tip {
          height: 18px;
          line-height: 18px;
          border-radius: 9px;
          color: #ffffff;
          font-size: 12px;
          padding: 0 5px;
          background-color: $mainGlod;
          position: absolute;
          right: -18px;
          top: -8px;
        }
      }

      >>>.el-menu-item:focus,
      .el-menu-item:hover {
        background: #F4F8FE;
      }

      >>>.is-active {
        background: #F4F8FE;
        .title {
          // background: #F4F8FE;
          box-sizing: content-box;
          background: linear-gradient(7.064707531409216e-7deg, #584DFF 40%, #1866ED 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
      }
    }
  }

  .userCenterInfo {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userCenter.vue